<template>
  <div :id="randomId" class="user-content-container">
    <component :is="'style'">
      code {
        {{ codeFontSize }}
      }
    </component>
    <div v-html="content" :style="style"></div>
  </div>
</template>

<script>

import permissionHelper from '../PermissionHelper'
import api from '../../api/api'
import userModel from '../../store/models/user'
import dialogs from '../../modules/dialogs'

export default {
  props: ["content"],
  data() {
    return {
      randomId: 0
    }
  },
  computed: {
      style() {

        var user = this.$store.getters.user;
        
        var size = user.getSetting(userModel.settingKeys.FONT_SIZE);
        var weight = user.getSetting(userModel.settingKeys.FONT_WEIGHT);
        var color = user.getSetting(userModel.settingKeys.FONT_COLOR);

        var ret = {};

        if (size !== 'default') ret.fontSize = size + 'px';
        if (weight !== 'default') ret.fontWeight = weight
        if (color != 'default') ret.color = color;

        return ret;
      },
      codeFontSize() {
        var user = this.$store.getters.user;
        var codeFontSize = user.getSetting(userModel.settingKeys.CODE_FONT_SIZE);
        return codeFontSize !== 'default' ? 'font-size: ' + codeFontSize + 'px' : '';
      }
  },
  created() {
    this.randomId = 'a' + Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  },
  methods: {
    clickImage(el) {
      event.preventDefault();
      window.open(el.srcElement.currentSrc, '_blank');
    },
    clickDownload(el) {
      event.preventDefault();      
      if (!permissionHelper.attachments.canDownload(this.$store.getters.user)) {
        dialogs.alertAsync('Please log in to download attachments');
      } else {
        var attachmentID = parseInt(el.currentTarget.attributes['data-ua-attachment'].value);
        api.get('/attachments/' + attachmentID)
          .then((response) => {
            // some browsers treat this window.open as a popup
            // for known browsers, use url replacement method in current window instead
            // (window.open is preferred if not treated as popup)
            var useNewWindow = true;
            if (navigator.userAgent.search("Firefox") > -1) useNewWindow = false;
            if (useNewWindow) {
              window.open(response.data);
            } else {
              window.location.href = response.data;
            }
          }).catch(() => {
            dialogs.alertAsync('We were unable to process that request.  If the issue persists, please contact an administrator');
          });
      }
    }
  },
  mounted() {    
    // force outer anchor href of live preview images to image src
    let images = document.querySelectorAll(`div#${this.randomId} img`);
    images.forEach((img) => {      
      img.addEventListener('click', this.clickImage);      
      // the outer element of a preview link has the non-temp version
      // sometimes browser pics that, sometimes the image source
      // this is a hack (should be fixed server-side), but let's
      // replace the outer anchor href with the img source that we
      // know is good...
      if (img.attributes["data-ua-attachment-preview"]) {
        if (img.attributes["data-ua-attachment-preview"].value ==="true") {
          var outerAnchor = img.parentElement;
          outerAnchor.href = img.src;
        }
      }      
    });  

    // ensure all links open in new window
    // if there's a direct post to /attachments/:id, add the data-ua-download so the js handler gets it
    let links = document.querySelectorAll(`div#${this.randomId} a`);
    links.forEach((link) => {
      link.target = "_blank";

      // here's another hack... some people are putting the /attachments/1234 link directly, so it doesn't include
      // the data-ua-download, and the api endpoint doesn't handle this well
      // let's check for /attachments/ and see if the host is utteraccess.com (or some likeness), and if so,
      // enforce the data-ua-download (but only if it's not a live preview?)      
      if (link.href.indexOf("utteraccess") > 0 && link.href.indexOf("/attachments/") > 0) {
        if (!link.attributes["data-ua-attachment"]) {
          if (!link.attributes["data-ua-download"]) {          
            link.setAttribute("data-ua-download", "true");
            var attachmentID = link.href.substring(link.href.lastIndexOf("/") + 1);
            link.setAttribute("data-ua-attachment", attachmentID);
          }
        }
      }
    });

    // get all the data-ua-download elements for handling
    let downloads = document.querySelectorAll(`div#${this.randomId} a[data-ua-download]`);
    downloads.forEach((dl) => {
      dl.addEventListener('click', this.clickDownload);
    });
  },
}
</script>

